import { calcAge } from "./formData";
import { JOB_HOLDER } from "./options";

export const PHONE_RE = /^[6-9]\d{9}$/;
export const PIN_RE = /^\d{6}$/;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const blank = (v) => v === null || v === undefined || String(v).trim() === "";

function required(errors, data, section, fields) {
  fields.forEach((f) => {
    if (blank(data[section][f])) errors[`${section}.${f}`] = "This field is required";
  });
}

function format(errors, data, key, re, msg) {
  const [section, f] = key.split(".");
  const v = data[section][f];
  if (!blank(v) && !re.test(String(v).trim())) errors[key] = msg;
}

const PHONE_MSG = "Enter a valid 10-digit Indian mobile number";
const PIN_MSG = "PIN code must be 6 digits";
const EMAIL_MSG = "Enter a valid email address";

const validators = {
  1: (d, e) => {
    required(e, d, "private", ["applicant_name", "applicant_mobile", "applicant_full_address", "relationship_with_candidate"]);
    format(e, d, "private.applicant_mobile", PHONE_RE, PHONE_MSG);
  },
  2: (d, e) => {
    required(e, d, "candidate", ["profile_for", "full_name", "dob", "place_of_birth", "mother_tongue", "height", "religion", "nationality", "marital_status", "food_habits"]);
    const { dob, profile_for } = d.candidate;
    if (dob) {
      const age = calcAge(dob);
      if (new Date(`${dob}T00:00:00`) > new Date()) e["candidate.dob"] = "Date of birth cannot be in the future";
      else if (profile_for === "bride" && age < 18) e["candidate.dob"] = "Bride must be at least 18 years old";
      else if (profile_for === "groom" && age < 21) e["candidate.dob"] = "Groom must be at least 21 years old";
    }
    if (d.meta.manglik_yes && (blank(d.candidate.manglik) || d.candidate.manglik === "NA")) e["candidate.manglik"] = "Please add manglik details";
    if (d.meta.pc_yes && (blank(d.candidate.physically_challenged) || d.candidate.physically_challenged === "NA")) e["candidate.physically_challenged"] = "Please add details";
  },
  3: (d, e) => {
    required(e, d, "candidate", ["highest_qualification", "occupation"]);
    if (d.candidate.occupation === JOB_HOLDER && blank(d.candidate.job_details)) e["candidate.job_details"] = "Please add your job details";
  },
  4: (d, e) => required(e, d, "family", ["father_name", "mother_name", "family_type"]),
  5: (d, e) => {
    required(e, d, "private", ["present_address", "present_pin", "present_phone"]);
    format(e, d, "private.present_pin", PIN_RE, PIN_MSG);
    format(e, d, "private.present_phone", PHONE_RE, PHONE_MSG);
    format(e, d, "private.present_whatsapp", PHONE_RE, PHONE_MSG);
    format(e, d, "private.present_email", EMAIL_RE, EMAIL_MSG);
    if (!d.private.same_as_present) {
      required(e, d, "private", ["permanent_address", "permanent_pin"]);
      format(e, d, "private.permanent_pin", PIN_RE, PIN_MSG);
      format(e, d, "private.permanent_phone", PHONE_RE, PHONE_MSG);
      format(e, d, "private.permanent_whatsapp", PHONE_RE, PHONE_MSG);
      format(e, d, "private.permanent_email", EMAIL_RE, EMAIL_MSG);
    }
  },
  6: (d, e) => {
    const { age_min, age_max } = d.preferences;
    ["age_min", "age_max"].forEach((k) => {
      const v = d.preferences[k];
      if (!blank(v) && (!/^\d+$/.test(String(v)) || Number(v) < 18 || Number(v) > 99)) e[`preferences.${k}`] = "Enter an age between 18 and 99";
    });
    if (!blank(age_min) && !blank(age_max) && Number(age_min) > Number(age_max)) e["preferences.age_max"] = "Maximum age must be greater than minimum age";
  },
  7: (d, e, o) => {
    if (o.admin) return;
    if (!d.uploads.profile_photo) e["uploads.profile_photo"] = "Please upload a profile photo";
    if (!d.agreement.consent) e["agreement.consent"] = "You must accept the terms and privacy policy";
  },
};

export function validateStep(step, data, opts = {}) {
  const errors = {};
  if (validators[step]) validators[step](data, errors, opts);
  return errors;
}
